import { Directive, ComponentFactoryResolver, ViewContainerRef } from '@angular/core';
import { TargetAppService } from '../../core/services/parameter';
import { ComponentProviderDirective } from '../../core/directives/component-provider.directive';
import { SidebarProviderService } from '../services/sidebar-provider.service';

/**
 * Directive for change the sidebar visual element content
 * 
 * Extends from ``ComponentProviderDirective``
 * 
 * Provides ``SidebarProviderService`` for use in ``ComponentProviderDirective``
 */
@Directive({
  selector: '[app-sidebar]'
})
export class DinamicSidebarDirective extends ComponentProviderDirective {

  constructor(
    protected app: TargetAppService,
    protected provider: SidebarProviderService,
    protected componentFactoryResolver: ComponentFactoryResolver,
    protected viewContainerRef: ViewContainerRef
  ) {
    super(app, provider, componentFactoryResolver, viewContainerRef);
  }
}
